import theme from './theme';

const colors = {
  theme,
};

const sizes = {
  none: '0px',
  sm: '4px',
  md: '8px',
  lg: '16px',
};

const themeFree = {
  colors,
  sizes,
};

export default themeFree;
